// Generated by psc version 0.10.2
"use strict";
var $foreign = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-eff/src/Control/Monad/Eff/Unsafe.js");
var Control_Monad_Eff = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-eff/src/Control/Monad/Eff.purs");
var Control_Semigroupoid = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Semigroupoid.purs");
var unsafePerformEff = function ($0) {
    return Control_Monad_Eff.runPure($foreign.unsafeCoerceEff($0));
};
module.exports = {
    unsafePerformEff: unsafePerformEff, 
    unsafeCoerceEff: $foreign.unsafeCoerceEff
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-eff/src/Control/Monad/Eff/Unsafe.purs
// module id = 49
// module chunks = 0